<template>
  <div>
    <vue-element-loading :active="!show" :is-full-screen="true" />
    <b-row v-if="getUuidPatientSelected">
      <b-col class="mt-4" cols="12" md="3">
        <router-link :to="{ name: 'patientdata', params: {pt_uuid: getUuidPatientSelected } }" tag="div" class="box_menu d-flex align-items-center">
          <SVGUserInformation class="account-ico w-25 h-100 p-3" />
          <span class="ml-3">{{ $t('home_user.personal_information') }}</span>
        </router-link>
      </b-col>
      <b-col class="mt-4" cols="12" md="3">
        <router-link :to="{ name: 'userhistorial' }" tag="div" class="box_menu d-flex align-items-center">
          <SVGUserHistorial class="account-ico w-25 h-100 p-3" />
          <span class="ml-3">{{ $t('home_user.orders_history') }}</span>
        </router-link>
      </b-col>
      <b-col class="mt-4" cols="12" md="3">
        <router-link :to="{ name: 'useraddress', params: {pt_uuid: getUuidPatientSelected } }" tag="div" class="box_menu d-flex align-items-center">
          <SVGUserAddress class="account-ico w-25 h-100 p-3" />
          <span class="ml-3">{{ $t('home_user.my_addresses') }}</span>
        </router-link>
      </b-col>
      <!-- <b-col class="mt-4" cols="12" md="3">
        <router-link :to="{ name: 'userprogram', params: {pt_uuid: getUuidPatientSelected } }" tag="div" class="box_menu d-flex align-items-center">
          <SVGUserHistorial class="w-25 h-100 p-3" />
          <span class="ml-3">{{$t('home_user.programs')}}</span>
        </router-link>
      </b-col> -->
    </b-row>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
import SVGUserInformation from "@/static/ico/datos_personales.svg";
import SVGUserHistorial from "@/static/ico/historial_pedidos.svg";
import SVGUserAddress from "@/static/ico/mis_direcciones.svg";

export default {
  name: "cardlist-home",
  components: {
    SVGUserInformation,
    SVGUserHistorial,
    SVGUserAddress,
  },
  data() {
    return {
      show: false,
    };
  },
  computed: {
    ...mapGetters("naturalperson", ["getUuidPatientSelected"]),
  },
  fallbackI18n: {
    messages: {
      und: {
        home_user: {
          personal_information: "Personal Information",
          orders_history: "Orders History",
          my_addresses: "My Addresses",
          programs: "Programs",
        },
      },
    },
  },
  mounted: function() {
    this.show = true;
  },
  methods: {
    onItemClick(item) {
      this.$router.push(this.link_routes[item]);
    },
  },
};
</script>


<style scoped lang="scss">
.box_menu {
  text-transform: uppercase;
  font-size: $font-size-medium;
  border: 1px solid $grey1-color;
  cursor: pointer;
}

.box_menu span {
  color: $grey3-color;
  display: inline-block;
}

.box_menu svg {
  flex-shrink: 0;
  display: inline-block;
  border-right: 1px solid $grey1-color;
  fill: $corp-color2 !important;
}

</style>
